
export const euportal = {
  'euportal.title': 'Subvention pour l\'Amélioration de l\'Irrigation Intelligente',
  'euportal.subtitle': 'Formulaire de Demande - Référence : EAGF/IRR/2024/03',
  'euportal.header': 'Fonds Européen Agricole de Garantie',
  'euportal.portalId': 'ID du Portail : EAGF-24-ONLINE',
  'euportal.applicantInfo': 'Informations sur le Demandeur',
  'euportal.applicantInfoDesc': 'Veuillez fournir des informations précises sur votre ferme.',
  'euportal.requiredDocs': 'Documentation Requise',
  'euportal.uploadLandProof': 'Télécharger la Preuve de Propriété Foncière',
  'euportal.uploadIrrigationForm': 'Télécharger le Formulaire de Déclaration d\'Irrigation (PDF signé)',
  'euportal.dragDrop': 'Cliquez pour télécharger ou glissez-déposez',
  'euportal.fileTypes': 'PDF, JPG ou PNG (max. 10 Mo)',
  'euportal.pdfOnly': 'PDF uniquement (max. 5 Mo)',
  'euportal.submitApp': 'Soumettre la Demande',
  'euportal.disclaimer': 'Ceci est un environnement simulé à des fins de formation uniquement.',
  'euportal.privacy': 'Politique de Confidentialité',
  'euportal.terms': 'Conditions d\'Utilisation',
  'euportal.contact': 'Contact',
  'euportal.accessibility': 'Accessibilité',
  'euportal.downloadCompleted': 'Télécharger le PDF complété',
  'euportal.submitToPortal': 'Soumettre au Portail UE (simulé)',
  'euportal.appCompletedMessage': 'Vous avez complété votre demande de subvention avec AgriTool Advisor',
} as const;
